import * as React from "react";
import type { SVGProps } from "react";
const SvgBackpackCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#backpack-check_svg__a)">
      <path d="M20.93 10.88a1.007 1.007 0 1 0-2 .25q.058.434.07.87v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a7 7 0 0 1 9.62-6.49A1 1 0 0 0 15.93 5c.077-.217.07-.67.07-.67s-.003-.217 0-.33V3a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1a9 9 0 0 0-5 8v9a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9a8 8 0 0 0-.07-1.12M10 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1z" />
      <path d="M7 11a1 1 0 0 0-1 1v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-4a1 1 0 0 0-2 0v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-6a1 1 0 0 0-1-1" />
      <path d="M10.83 11.45a1 1 0 0 0-1.66 1.1l2 3A1 1 0 0 0 12 16a1 1 0 0 0 .82-.43l7-10a1 1 0 0 0-1.64-1.14L12 13.23z" />
    </g>
    <defs>
      <clipPath id="backpack-check_svg__a">
        <path fill="#fff" d="M3 0h18v24H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBackpackCheck;
